<form name="HolidayForm" #HolidayForm="ngForm" (ngSubmit)="FilterValidate(HolidayForm)">
    <div class="card">
        <div class="card-header">
            <label>Optional Holiday</label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-4 px-1 pt-2">
                    <label>Holiday</label>
                    <ng-select name="Holiday" placeholder="Select Holiday"
                        [(ngModel)]="Filter.ESS_CompanyHolidayMasterID" (change)="setOtherDetail()">
                        <ng-option *ngFor="let OpHoliday of OpHolidays"
                            [value]="OpHoliday.ESS_CompanyHolidayMasterID">{{OpHoliday.HolidayName}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select holiday type.
                    </div>
                </div>
                <div class="col-md-3 px-1 pt-2">
                    <label>Date</label>
                    <input type="text" class="form-control text-label-light" placeholder="Ex. Date" id="Date"
                        name="Date" [(ngModel)]="FormFilter.Date" #Date="ngModel" maxlength="100" disabled>
                </div>
                <div class="col-md-3 px-1 pt-2">
                    <label>Leave Type</label>
                    <input type="text" class="form-control text-label-light" placeholder="Ex. Type" id="Type"
                        name="Type" [(ngModel)]="FormFilter.Type" #Type="ngModel" maxlength="100" disabled>
                </div>
                <div class="col-md-2 px-1 pt-2">
                    <label>Holiday Type</label>
                    <input type="text" class="form-control text-label-light" placeholder="Ex. Holiday Type"
                        id="HolidayType " name="HolidayType" [(ngModel)]="FormFilter.HolidayType" #HolidayType="ngModel"
                        maxlength="100" disabled>
                </div>
                <div class="col-md-12 px-1 pt-2">
                    <label>Remark</label>
                    <textarea type="text" id="Remark" name="Remark" [(ngModel)]="FormFilter.Remark"
                        class="md-textarea md-textarea-auto form-control" style="resize: none; height: 22px;"
                        mdbInput></textarea>
                    <div class="invalid-feedback">
                        Please select remark.
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary" [disabled]="isDisabled" (click)="close()"><i
                        class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Request':'Loading...'}}</button>
            </div>
        </div>
    </div>
</form>